export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
		},
	],
	singular_model_name_spanish: 'Tipo de ruta',
	plural_model_name_spanish: 'Tipo de rutas',
	create_model_name_spanish: 'Nuevo Tipo de ruta',
	text_delete: 'el',
}